import React, { useState, useCallback, useEffect, useContext } from 'react';
import LayoutContainer from 'components/layout/LayoutContainer';
import AdminHeader from 'components/header';
import Card from 'components/inputs/Card';
import { BsSearch } from 'react-icons/bs';
import Button from 'components/inputs/Button';
import { FiEdit2 } from 'react-icons/fi';
import { RiDeleteBinLine } from 'react-icons/ri';
import { Row, Col, Spinner } from 'react-bootstrap';
import * as _ from 'lodash';
import SearchBox from 'components/general/SearchBox';
import { useDispatch, useSelector } from 'react-redux';
// import Pagination from 'components/general/Pagination';
import ReactPagination from 'components/general/ReactPagination';
import { Modal } from 'react-bootstrap';
import { DELETE_MODULE, FETCH_MODULE, GET_MODULE } from 'actions/module';
import ModuleForm from './ModuleForm';
import DeleteModal from 'components/general/DeleteModal';
import { DELETE_STATUS_CODE } from 'components/common/constant';
import { BiSort } from 'react-icons/bi';
import { MdOutlineSettingsSuggest } from 'react-icons/md';
// import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { NavContext } from 'components/privateRoute/PrivateRoute';

const ModuleList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  // const history = useHistory();
  const { navigateTo } = useContext(NavContext);
  const [showForm, setShowForm] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [searchText, setSearchText] = useState('');
  // const [allModuleData, setAllModuleData] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [moduleId, setModuleId] = useState('');
  const [sortByItem, setSortByItem] = useState({ item: '', order: '' });
  const [pageWiseModuleData, setPageWiseModuleData] = useState([]);

  const page = useSelector((state) => state.module.page, _.isEqual);
  const totalData = useSelector((state) => state.module.totalResults, _.isEqual);
  const limit = useSelector((state) => state.module.limit, _.isEqual);
  const totalPages = useSelector((state) => state.module.totalPages, _.isEqual);
  const moduleList = useSelector((state) => state.module.modules, _.isEqual);
  const isLoader = useSelector((state) => state.module.isLoading, _.isEqual);

  const getModule = useCallback(
    (data = {}) => {
      if (searchText) {
        const searchModuleData = {
          ...data,
          search: searchText,
          limit: 9999,
        };
        dispatch({
          type: FETCH_MODULE.REQUEST,
          payload: searchModuleData,
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === 200) {
                setPageWiseModuleData(res.data.results);
              }
            }
          },
        });
      } else {
        const moduleData = {
          ...data,
          limit: 9999,
        };
        dispatch({
          type: FETCH_MODULE.REQUEST,
          payload: moduleData,
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === 200) {
                setPageWiseModuleData(res.data.results);
              }
            }
          },
        });
      }
    },
    [pageWiseModuleData, searchText]
  );

  const getModuleDetail = useCallback((id) => {
    dispatch({ type: GET_MODULE.REQUEST, payload: id });
  }, []);

  const handleCloseDeleteModel = () => {
    setShowDeleteModal(false);
    setModuleId('');
  };

  const deleteModule = useCallback(
    () =>
      dispatch({
        type: DELETE_MODULE.REQUEST,
        payload: moduleId,
        cb: (res) => {
          if (_.get(res, 'status', '') === DELETE_STATUS_CODE) {
            handleCloseDeleteModel();
            getModule({ page: 1 });
          }
        },
      }),
    [moduleId]
  );

  useEffect(() => {
    getModule();
  }, []);

  const handleSearch = () => {
    getModule({});
  };

  // useEffect(() => {
  //   setAllModuleData(_.filter(moduleData, (item) => startsWith(_.get(item, 'name', ''), searchText)));
  // }, [searchText, moduleList, pageWiseModuleData]);

  const handlePageClick = useCallback(
    (page) => {
      if (sortByItem.item && sortByItem.order) {
        getSortByItem(sortByItem.item, sortByItem.order, page);
      } else {
        const data = {
          page: page.selected + 1,
        };
        getModule(data);
      }
    },
    [sortByItem]
  );

  const getSortByItem = (name, order, page) => {
    const sortedOrder = order || 'asc';
    if (page) {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
        page: page.selected + 1,
      };
      getModule(data);
    } else {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
      };
      getModule(data);
    }
  };

  const handleSorting = (sortItem, dataItem) => {
    if (dataItem.item === sortItem) {
      const sortOrder = dataItem.order === 'asc' ? 'desc' : 'asc';
      setSortByItem({ item: sortItem, order: sortOrder });
      getSortByItem(sortItem, sortOrder);
    } else {
      setSortByItem({ item: sortItem, order: 'asc' });
      getSortByItem(sortItem, 'asc');
    }
  };

  const handleCloseFormModule = () => {
    setShowForm(false);
    setIsEdit(false);
  };

  return (
    <>
      <LayoutContainer>
        <AdminHeader title={t('header.modules')} />
        <div className="page-content-wrapper scrollable">
          <div className="roleList-page">
            <Card>
              <div className="roleList-page-wrapper">
                <Row className="roleList-search-box">
                  <Col xl={10} lg={9} md={8} className="roleList-search-inputBox">
                    <SearchBox
                      value={searchText}
                      preIcon={<BsSearch />}
                      onChange={(e) => setSearchText(e.target.value)}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          handleSearch();
                        }
                      }}
                    />
                  </Col>
                  <Col xl={2} lg={3} md={4} className="roleList-search-boxButton">
                    <Button
                      className="roleList-search-box-Btn"
                      onClick={() => {
                        setShowForm(true);
                        setIsEdit(false);
                      }}
                    >
                      {t('button.addModule')}
                    </Button>
                  </Col>
                </Row>
                <div className="roleList-table">
                  <div className="table-responsive">
                    <table className="record-list-table">
                      <thead>
                        <tr>
                          <th>
                            <div className="sorting">
                              <span>{t('moduleForm.moduleName')}</span>
                              <span className="ico" onClick={() => handleSorting('name', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>{t('moduleForm.configure')}</span>
                            </div>
                          </th>
                          <th className="action-col">
                            <span>{t('moduleForm.action')}</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoader ? (
                          <tr>
                            <td colSpan={10} className="border-0">
                              <div className="loader--block">
                                <Spinner as="span" animation="border" size="sm" role="status" />
                                <span className="ps-2">{t('placeHolder.loading')}</span>
                              </div>
                            </td>
                          </tr>
                        ) : _.isEmpty(moduleList) ? (
                          <tr>
                            <td colSpan={3} className="border-0">
                              <div className="empty-data-block">{t('moduleForm.noData')}</div>
                            </td>
                          </tr>
                        ) : (
                          !(isLoader || _.isUndefined(isLoader)) &&
                          _.map(moduleList, (item, key) => {
                            return (
                              <>
                                <tr key={`module-${key}`}>
                                  <td>{_.get(item, 'name', '')}</td>
                                  <td>
                                    <div className="configuration-icon" onClick={() => navigateTo(`/configureModule/${_.get(item, 'id', '')}`)}>
                                      <MdOutlineSettingsSuggest size={19} />
                                    </div>
                                  </td>
                                  <td>
                                    <span
                                      className="roleList-table-editIcon"
                                      onClick={() => {
                                        setShowForm(true);
                                        getModuleDetail(_.get(item, 'id', ''));
                                        setIsEdit(true);
                                      }}
                                    >
                                      <FiEdit2 title="Edit" />
                                    </span>
                                    <span
                                      className="roleList-table-deleteIcon"
                                      onClick={() => {
                                        setShowDeleteModal(true);
                                        setModuleId(_.get(item, 'id', ''));
                                      }}
                                    >
                                      <RiDeleteBinLine title="Delete" />
                                    </span>
                                  </td>
                                </tr>
                              </>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                {!(isLoader || _.isUndefined(isLoader)) && !_.isEmpty(moduleList) && (
                  <ReactPagination
                    currentPage={page}
                    limit={limit}
                    total={totalData}
                    handlePageClick={(pageVal) => handlePageClick(pageVal)}
                    totalPages={totalPages}
                    marginPagesDisplayed={1}
                  />
                  // <Pagination currentPage={page} limit={limit} total={totalData} onPageChange={(pageVal) => handlePageClick(pageVal)} />
                )}
              </div>
            </Card>
          </div>
        </div>
        {showForm && (
          <Modal show={showForm} size="lg" centered>
            <ModuleForm onClose={handleCloseFormModule} isEdit={isEdit} onSuccess={getModule} />
          </Modal>
        )}
        {showDeleteModal && (
          <Modal show={showDeleteModal} centered onHide={handleCloseDeleteModel}>
            <DeleteModal title="module" onClose={handleCloseDeleteModel} onRemove={deleteModule} />
          </Modal>
        )}
      </LayoutContainer>
    </>
  );
};
export default ModuleList;
